import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const apiBase = process.env.REACT_APP_API_URL;

export default function TopPlayerWidget({ leagueId, tournamentName }) {
  const navigate = useNavigate();
  const [top, setTop] = useState(null);
  const [playerStats, setPlayerStats] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTopPlayer = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiBase}/api/top-player`, {
        params: { tournamentName },
      });
      if (res.data.player) {
        setTop(res.data.player);
        setPlayerStats(res.data.recentGames);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }, [tournamentName]);

  useEffect(() => {
    if (!tournamentName) return;
    fetchTopPlayer();
  }, [tournamentName, fetchTopPlayer]);

  if (loading || !top) return null;

  const avgRating = playerStats.length ? Math.round(playerStats.reduce((sum, s) => sum + s.rating, 0) / playerStats.length) : null;

  const MIN = 30;

  function getBadgeClass(rating) {
    if (rating >= 80) return "badge-elite";
    if (rating >= 65) return "badge-high";
    if (rating >= 50) return "badge-mid";
    if (rating >= 40) return "badge-average";
    return "badge-low";
  }

  function getBarColor(rating) {
    if (rating >= 80) return "bar-elite";
    if (rating >= 65) return "bar-high";
    if (rating >= 50) return "bar-mid";
    if (rating >= 40) return "bar-average";
    return "bar-low";
  }

  return (
    <div
      className="top-player-widget"
      onClick={() => navigate(`/dashboard/league/${leagueId}/player/${top.player_id}`)}
      style={{ cursor: "pointer" }}>
      <div className="tpw-body">
        <div className="tpw-info">
          <span className="avg-label">TOP PLAYER</span>
          <div className="tpw-version">RATING 1.0</div>
          <div className="tpw-name-row">
            <img src={`/teams/${top.team_logo}`} alt={top.team_name} className="tpw-team-logo" />
            <span className="tpw-name">{top.player_name}</span>
          </div>
          <div style={{ display: "flex", gap: "4px" }}>
            <div className="tpw-version">Avg</div>
            {avgRating && <div className={`tpw-rating ${getBadgeClass(avgRating)}`}>{avgRating}</div>}
          </div>
        </div>
        <div className="tpw-photo">
          <img src={`/players/${top.player_image}`} alt={top.player_name} onError={(e) => (e.target.style.display = "none")} />
        </div>
      </div>

      {!loading && playerStats.length > 0 && (
        <div className="tpw-chart">
          {playerStats.map((s, i) => {
            const heightPct = ((s.rating - MIN) / (100 - MIN)) * 100;
            return (
              <div className="tpw-bar-col" key={i}>
                <div className="tpw-bar-wrap">
                  <span className={`tpw-bar-label ${getBadgeClass(s.rating)}`}>{s.rating}</span>
                  <div className={`bar ${getBarColor(s.rating)}`} style={{ height: `${heightPct}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
